import { BarChart } from '../../components/molecules/Charts/BarChart';
import { FeatureContainer } from '../../components/molecules/Containers/FeatureContainer';
import React, { useState } from 'react';
import {
  QuizWithCompetenceAndQuestions,
  UserWithQuizToNoteDef
} from '../../types/quiz/quiz.def';
import { SubTitle } from '../../components/atoms/Texts/SubTitle';
import useStyle from './recapQuizClasse.style';
import { ContainerTwoThirds } from '../../components/layouts/ContainerTwoThirds';
import { ContainerFullWidth } from '../../components/layouts/ContainerFullWidth';
import { HeaderText } from '../../components/atoms/Texts/HeaderText';
import emojis from '../../theme/emoji';
import { Modal } from '../../components/organisms/Modals/Modal';
import { QuizRecapUsersTable } from '../../components/organisms/Table/QuizRecapUsersTable';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import { BackButton } from 'components/molecules/Buttons/BackButton';

interface RecapQuizClasseViewProps {
  quiz: QuizWithCompetenceAndQuestions;
  classe: { users: UserWithQuizToNoteDef[] };
  quizId: string;
}
export const RecapQuizClasseView = ({
  quiz,
  classe,
  quizId
}: RecapQuizClasseViewProps) => {
  const classes = useStyle();
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useMediaQuery('mobile');
  const [
    selectedUserResponse,
    setSelectedUser
  ] = useState<UserWithQuizToNoteDef | null>();
  const showStudentResponses = user => {
    setSelectedUser(user);
    setIsOpen(true);
  };
  return (
    <div className={classes.root}>
      <BackButton text="Retourner sur la page précédente" />
      <ContainerTwoThirds
        variant={'reverse'}
        col1={
          <FeatureContainer>
            <SubTitle text={quiz.name ? quiz.name : 'Quiz'} />
            <div className={classes.competenceBlock}>
              <p className={classes.textCompetenceBlock}>{quiz.desc}</p>
            </div>
          </FeatureContainer>
        }
        col2={
          <FeatureContainer>
            <SubTitle text="Compétences évaluées" />
            <div className={classes.competences}>
              {quiz.competences.map((competence, index) => (
                <div key={index} className={classes.competenceBlock}>
                  <p className={classes.textCompetenceBlock}>
                    {competence.name}
                  </p>
                </div>
              ))}
            </div>
          </FeatureContainer>
        }
      />
      {!isMobile && (
        <ContainerFullWidth>
          <FeatureContainer>
            <SubTitle text="Synthèse des réponses élèves" />
            <BarChart quiz={quiz} users={classe?.users} quizId={quizId} />
          </FeatureContainer>
        </ContainerFullWidth>
      )}
      <ContainerFullWidth>
        <HeaderText text="Liste des élèves" emoji={emojis['NerdFace']} />
        <QuizRecapUsersTable
          users={classe?.users}
          quizId={quizId}
          showStudentResponses={showStudentResponses}
        />
        {isOpen && (
          <Modal
            modalHead={'Réponse au quiz'}
            isShowingDefault={true}
            onCloseAction={() => setIsOpen(false)}
          >
            <div>
              {selectedUserResponse?.quiztonotes.find(
                qtn => qtn.quiz === quizId
              )?.responses.length ? (
                selectedUserResponse?.quiztonotes
                  .find(qtn => qtn.quiz === quizId)
                  ?.responses.map((response, index) => (
                    <div
                      key={index}
                      className={classes.finDeQuizAnswerContainer}
                    >
                      <h2>{response.question.name}</h2>
                      <p>
                        {response.reponse} {response?.isCorrect ? ' ✅' : ' ❌'}
                      </p>
                    </div>
                  ))
              ) : (
                <div className={classes.emptyAnswersContainer}>
                  <p>
                    Pas de réponses pour ce quiz{' '}
                    <span role="img" aria-label="emoji embarassé">
                      😕
                    </span>
                  </p>
                </div>
              )}
            </div>
          </Modal>
        )}
      </ContainerFullWidth>
    </div>
  );
};
